import React, { useEffect } from 'react';

import { useNotifications } from '@utils/hooks';

import { useStore, cardsActions } from '@modules';

export type TBindVerifyCardStatus = {
  onSuccess?: (bindStatus?: string) => void;
};

export const BindVerifyCardStatus: CustomFC<TBindVerifyCardStatus> = props => {
  const { children, onSuccess } = props;

  const [{ cards }, dispatch] = useStore();
  const { bindCardFailedNotification, bindCarsSuccessNotification } = useNotifications();

  const { bindStatus } = cards;

  const resetState = () => {
    dispatch(cardsActions.resetBindCardState());
  };

  useEffect(() => {
    const statusIsSucceeded = bindStatus === CONST.card3DS.statuses.succeeded;
    const statusIsFailed = bindStatus === CONST.card3DS.statuses.failed;

    if (statusIsSucceeded) {
      bindCarsSuccessNotification();
      resetState();
    }

    if (statusIsFailed) {
      bindCardFailedNotification();
      resetState();
    }

    if (bindStatus !== CONST.card3DS.statuses.pending) onSuccess?.(bindStatus);
  }, [bindStatus]);

  return <>{children}</>;
};

export default BindVerifyCardStatus;
